<template>
  <!-- Dashboard Content
	================================================== -->
  <div class="dashboard-content-container" data-simplebar>
    <div class="dashboard-content-inner">
      <!-- Dashboard Headline -->
      <div class="dashboard-headline">
        <h3>Tasks</h3>

        <!-- Breadcrumbs -->
        <nav id="breadcrumbs" class="dark">
          <ul>
            <li><a href="#">Home</a></li>
            <li><a href="#">Dashboard</a></li>
            <li>Tasks</li>
          </ul>
        </nav>
      </div>

      <!-- Row -->
      <div class="row">
        <!-- Dashboard Box -->
        <div class="col-xl-12">
          <div class="dashboard-box margin-top-0">
            <!-- Headline -->
            <div class="headline">
              <h3>
                <i class="icon-material-outline-email"></i>
                {{ totalTasks }} Tasks
              </h3>

              <button
                class="button sort-by ripple-effect-dark button-sliding-icon btn--height"
                title="Create Task"
                @click="openTaskModal('create')"
              >
                Create Task
                <i class="icon-material-outline-note-add"></i>
              </button>
            </div>

            <div class="content container padding-bottom-60 padding-top-20">
              <ve-table
                :columns="columns"
                :table-data="tableData"
                :border-around="true"
                :border-x="true"
                :border-y="true"
                :fixed-header="true"
              ></ve-table>
              <div class="table-pagination">
                <ve-pagination
                  :total="totalTasks"
                  :page-index="pageIndex"
                  :page-size="pageSize"
                  @on-page-number-change="pageNumberChange"
                  @on-page-size-change="pageSizeChange"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <app-footer></app-footer>

      <!-- Task Popup
      ================================================== -->
      <div v-show="isModalOpen" class="mfp-bg my-mfp-zoom-in mfp-ready"></div>
      <div
        v-show="isModalOpen"
        class="mfp-wrap mfp-close-btn-in mfp-auto-cursor my-mfp-zoom-in mfp-ready"
        tabindex="-1"
        style="top: 0px; position: absolute; height: 409px;"
      >
        <div class="mfp-container mfp-inline-holder">
          <div class="mfp-content">
            <div id="small-dialog-2" class="zoom-anim-dialog dialog-with-tabs">
              <!--Tabs -->
              <div class="sign-in-form">
                <ul class="popup-tabs-nav" style="pointer-events: none;">
                  <li>
                    <a href="#tab" title="Edit Task"
                      >{{ modalActionTitle }} Task</a
                    >
                  </li>
                </ul>

                <div class="popup-tabs-container">
                  <!-- Tab -->
                  <div class="popup-tab-content" id="tab" style="">
                    <!-- Welcome Text -->
                    <div class="welcome-text">
                      <h3>{{ modalActionTitle }} Task</h3>
                      <span> </span>
                    </div>

                    <!-- Form -->
                    <form method="post">
                      <input
                        type="text"
                        class="with-border"
                        ref="taskName"
                        v-model="taskName"
                        required
                        v-bind:autofocus="isModalOpen"
                      />
                    </form>

                    <!-- Button -->
                    <button
                      class="
                      button
                      full-width
                      ripple-effect
                      margin-top-10
                      my-4 col-6 d-flex justify-content-center
                      
                      "
                      type="submit"
                      style="width: 30px;"
                      @click="submitTaskForm()"
                      :class="[isLoading ? 'isDisabled text-white' : '']"
                    >
                      {{ submitButtonTitle }}
                      <div v-if="isLoading" class="loader ml-1"></div>
                    </button>
                  </div>
                </div>
              </div>
              <button
                @click="closeTaskModal()"
                title="Close Task Popup"
                type="button"
                class="mfp-close"
              ></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Dashboard Content / End -->
</template>

<script>
  /* eslint-disable no-console */
  import { AppFooter } from '../../../partials/user-dashboard';
  import {
    ALL_TASKS,
    ALL_TASKS_AND_SUBTASKS,
    CREATE_TASK,
    DELETE_TASK,
    SHOW_TASK,
    UPDATE_TASK,
  } from '../../../../core/config/endpoints/tasks';
  import { deleteCall, getCall, patchCall, postCall } from '../../../../core/services/http.service';
  import Snackbar from 'node-snackbar';
  import modalAction from '../../../../core/enums/modal-actions';
  import Vue from 'vue';

export default {
  name: "AdminTasks",
  components: {
    AppFooter,
  },
  data() {
    return {
      allTasks: [],

      isModalOpen: false,
      modalActionTitle: "",
      taskName: "",
      taskId: 0,
      submitButtonTitle: "",
      isNewTask: true,

      isLoading: false,

      totalTasks: 0,
      pageIndex: 1,
      pageSize: 10,
      fixedHeader: true,
      columns: [
        {
          field: "",
          key: "#",
          title: "#",
          align: "center",
          renderBodyCell: ({ rowIndex }) => {
            return (this.pageIndex - 1) * this.pageSize + rowIndex + 1;
          },
        },
        {
          field: "name",
          key: "name",
          title: "Name",
          align: "center",
        },
        {
          field: "",
          key: "action",
          title: "Action",
          width: "",
          center: "left",
          // eslint-disable-next-line no-unused-vars
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                <button
                  class="button text-white bg-success"
                  style="color:#198754; "
                  on-click={() => this.openTaskModal("view", rowIndex)}
                >
                  <i class="icon-feather-eye"></i>
                </button>
                &nbsp;
                <button
                  class="button text-white bg-primary"
                  on-click={() => this.openTaskModal("edit", rowIndex, h)}
                >
                  <i class="icon-feather-edit"></i>
                </button>
                &nbsp;
                <button
                  class="button text-white bg-danger"
                  on-click={() => this.deleteTask(rowIndex)}
                >
                  <i class="icon-feather-trash-2"></i>
                </button>
              </span>
            );
          },
        },
      ],
    };
  },
  watch: {
    isModalOpen: function() {
      if (this.isModalOpen) {
        let self = this;
        Vue.nextTick().then(function() {
          console.log(self.$refs.taskName.focus());
        });
      }
    },
  },
  computed: {
    tableData() {
      const { pageIndex, pageSize } = this;
      return this.allTasks.slice(
        (pageIndex - 1) * pageSize,
        pageIndex * pageSize
      );
    },
    // total count
    totalCount() {
      return this.allTasks.length;
    },
  },
  created() {
    return this.getAllTasks();
  },
  methods: {
    getAllTasks() {
      this.$store.commit("setIsLoaded", true);
      getCall(ALL_TASKS)
        .then(response => {
          this.allTasks = response.data.data;
          this.totalTasks = response.data.data.length;
        })
        .catch(error => {
          this.$toast.error(`${error.response.data.message}`);
        })
        .finally(() => {
          this.$store.commit("setIsLoaded", false);
        });
    },

    createTask() {
      this.isLoading = true;
      postCall(CREATE_TASK, {
        name: this.taskName,
      })
        .then(() => {
          this.getAllTasks();
          this.$toast.success(`Successfully added the '${this.taskName}' task`);
        })
        .catch(error => {
          this.$toast.error(`${error.response.data.message}`);
        })
        .finally(() => {
          this.isLoading = false;
          this.closeTaskModal();
        });
    },

    updateTask(taskId, updatedTaskName) {
      this.isLoading = true;
      patchCall(UPDATE_TASK.TASK(taskId), {
        name: updatedTaskName,
      })
        .then(response => {
          console.log(response.data);
        })
        .catch(error => {
          this.$toast.error(`${error.response.data.message}`);
        })
        .finally(() => {
          this.isLoading = false;
          this.closeTaskModal();
        });
    },

    deleteTask(rowIndex) {
      let taskId = this.allTasks[rowIndex].id;
      deleteCall(DELETE_TASK.TASK(taskId))
        .then(response => {
          console.log(response);
          this.allTasks.splice(rowIndex, 1);
          this.totalTasks = this.allTasks.length;
          Snackbar.show({
            text: "Deleted!",
            pos: "bottom-center",
            showAction: false,
            actionText: "Dismiss",
            duration: 2000,
            textColor: "#fff",
            backgroundColor: "#383838",
          });
        })
        .catch(error => {
          this.$toast.error(`${error.response.data.message}`);
        })
        .finally(() => {});
    },

    submitTaskForm() {
      if (this.taskName === "")
        return this.$toast.error(`Please enter a valid task name`);

      if (!this.isNewTask) {
        this.updateTask(this.taskId, this.taskName);
      } else {
        this.createTask();
      }
    },

    getSubtasks() {},

    openTaskModal(action, rowIndex, row) {
      console.log(row);
      if (action === modalAction.CREATE) {
        this.modalActionTitle = "Create";
        this.isNewTask = true;
        this.taskName = "";
        this.submitButtonTitle = "Create New";
      }

      if (action === modalAction.VIEW) {
        this.modalActionTitle = "View";
        // this.submitButtonTitle = '' // we'll hide the form and show a table of subtasks
      }

      if (action === modalAction.EDIT) {
        this.modalActionTitle = "Edit";
        this.isNewTask = false;
        this.submitButtonTitle = "Save";
        this.taskName = this.allTasks[rowIndex].name;
        this.taskId = this.allTasks[rowIndex].id;
      }

      this.isModalOpen = true;
      console.log(rowIndex);
    },
    closeTaskModal() {
      this.isModalOpen = false;
      this.taskName = "";
      this.taskId = 0;
    },

    allTasksWithSubtasks() {
      this.$store.commit("setIsLoaded", true);
      getCall(ALL_TASKS_AND_SUBTASKS)
        .then(response => {
          console.log(response);
        })
        .catch(error => {
          this.$toast.error(`${error.response.data.message}`);
        })
        .finally(() => {
          this.$store.commit("setIsLoaded", false);
        });
    },

    showTask(taskId) {
      this.$store.commit("setIsLoaded", true);
      getCall(SHOW_TASK.TASK(taskId))
        .then(response => {
          console.log(response);
        })
        .catch(error => {
          this.$toast.error(`${error.response.data.message}`);
        })
        .finally(() => {
          this.$store.commit("setIsLoaded", false);
        });
    },

    // page number change
    pageNumberChange(pageIndex) {
      this.pageIndex = pageIndex;
    },
    // page size change
    pageSizeChange(pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    },
  },
};
</script>

<style>
.btn--height {
  height: 46px !important;
  right: 15px !important;
}
.heavy-z-index {
  z-index: 99999999 !important;
  box-shadow: 0 2px 30px 0 rgb(15 18 18 / 49%) !important;
  place-content: center !important;
}
.isDisabled {
  cursor: not-allowed !important ;
  opacity: 0.5 !important ;
  text-decoration: none !important ;
  pointer-events: none !important ;
  background-color: #f0f0f0;
}
</style>
